import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'react-bootstrap-modal'

import ExternalDayForm  from './ExternalDayForm'

export default class AddExternalDay extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentDay: PropTypes.object,
    updateFav: PropTypes.func
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, currentDay } = this.props

    return (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <ExternalDayForm
            user={this.props.user}
            currentDay={currentDay}
            onSave={(event, dayIndex) => onClose(true, event, dayIndex)}
            updateFav= {(res) => {
              this.props.updateFav(res)
            }}
          />
          <i className="event-modal__close icon-close" onClick={() => onClose()} />
        </Modal.Body>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// src/components/TripPlanner/AddExternalDayModal.js